import React from "react";
import SMediaServices from '../../components/SMediaServices/SMediaServices';
const sMediaServices = () => {

  return (
    <>
      {/* Footer Section  */}
      <section>
        <SMediaServices />
      </section>
    </>
  );
};

export default sMediaServices;